"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STORE = exports.SwapAccountMobile = exports.SwapAccount = exports.Companies = exports.Locales = exports.filterHeaderFooterData = exports.headerConfigData = exports.companyNameData = exports.AccountMenuItemUrl = exports.AccountMenuItemId = exports.AccountMenuItemIcon = exports.AccountMenuItemLabel = exports.withTranslation = exports.checkMenuItemPermission = exports.POReplacePrompt = exports.myAccountFooterDefaultItems = exports.myAccountMenuDefaultItems = exports.accountMenuData = exports.ColumnMenu = exports.SimpleHeader = exports.SimpleFooter = exports.FullHeaderDesktop = exports.StructuredFullHeader = exports.StructuredFullFooter = void 0;

var FullStructuredContentFooter_1 = require("./Footer/FullStructuredContentFooter");

Object.defineProperty(exports, "StructuredFullFooter", {
  enumerable: true,
  get: function get() {
    return __importDefault(FullStructuredContentFooter_1).default;
  }
});

var FullStructuredHeader_1 = require("./Header/FullStructuredHeader");

Object.defineProperty(exports, "StructuredFullHeader", {
  enumerable: true,
  get: function get() {
    return __importDefault(FullStructuredHeader_1).default;
  }
});

var Desktop_1 = require("./Header/FullStructuredHeader/Desktop");

Object.defineProperty(exports, "FullHeaderDesktop", {
  enumerable: true,
  get: function get() {
    return __importDefault(Desktop_1).default;
  }
});

var SimpleFooter_1 = require("./Footer/SimpleFooter");

Object.defineProperty(exports, "SimpleFooter", {
  enumerable: true,
  get: function get() {
    return __importDefault(SimpleFooter_1).default;
  }
});

var SimpleHeader_1 = require("./Header/SimpleHeader");

Object.defineProperty(exports, "SimpleHeader", {
  enumerable: true,
  get: function get() {
    return __importDefault(SimpleHeader_1).default;
  }
});

var ColumnMenu_1 = require("./Header/Helpers/ColumnMenu");

Object.defineProperty(exports, "ColumnMenu", {
  enumerable: true,
  get: function get() {
    return __importDefault(ColumnMenu_1).default;
  }
});

var Menu_data_1 = require("./common/Menus/Menu.data");

Object.defineProperty(exports, "accountMenuData", {
  enumerable: true,
  get: function get() {
    return Menu_data_1.accountMenuData;
  }
});
Object.defineProperty(exports, "myAccountMenuDefaultItems", {
  enumerable: true,
  get: function get() {
    return Menu_data_1.myAccountMenuDefaultItems;
  }
});
Object.defineProperty(exports, "myAccountFooterDefaultItems", {
  enumerable: true,
  get: function get() {
    return Menu_data_1.myAccountFooterDefaultItems;
  }
});

var Menu_models_1 = require("./common/Menus/Menu.models");

Object.defineProperty(exports, "AccountMenuItemLabel", {
  enumerable: true,
  get: function get() {
    return Menu_models_1.AccountMenuItemLabel;
  }
});
Object.defineProperty(exports, "AccountMenuItemIcon", {
  enumerable: true,
  get: function get() {
    return Menu_models_1.AccountMenuItemIcon;
  }
});
Object.defineProperty(exports, "AccountMenuItemId", {
  enumerable: true,
  get: function get() {
    return Menu_models_1.AccountMenuItemId;
  }
});
Object.defineProperty(exports, "AccountMenuItemUrl", {
  enumerable: true,
  get: function get() {
    return Menu_models_1.AccountMenuItemUrl;
  }
});

var POReplacePrompt_1 = require("./Header/BarcodeScanner/POReplacePrompt");

Object.defineProperty(exports, "POReplacePrompt", {
  enumerable: true,
  get: function get() {
    return POReplacePrompt_1.POReplacePrompt;
  }
});

var util_1 = require("./common/util");

Object.defineProperty(exports, "checkMenuItemPermission", {
  enumerable: true,
  get: function get() {
    return util_1.checkMenuItemPermission;
  }
}); // Export Enums

var Menu_content_1 = require("./common/Menus/Menu.content");

Object.defineProperty(exports, "withTranslation", {
  enumerable: true,
  get: function get() {
    return Menu_content_1.withTranslation;
  }
}); // Export Header Config Settings

var HeaderConfig_1 = require("./common/HeaderConfig/HeaderConfig");

Object.defineProperty(exports, "companyNameData", {
  enumerable: true,
  get: function get() {
    return HeaderConfig_1.companyNameData;
  }
});
Object.defineProperty(exports, "headerConfigData", {
  enumerable: true,
  get: function get() {
    return HeaderConfig_1.headerConfigData;
  }
});

var util_2 = require("./common/Contentful/util");

Object.defineProperty(exports, "filterHeaderFooterData", {
  enumerable: true,
  get: function get() {
    return util_2.filterHeaderFooterData;
  }
});
Object.defineProperty(exports, "Locales", {
  enumerable: true,
  get: function get() {
    return util_2.Locales;
  }
});
Object.defineProperty(exports, "Companies", {
  enumerable: true,
  get: function get() {
    return util_2.Companies;
  }
});

var SwapAccount_1 = require("./Header/SwapAccount/SwapAccount");

Object.defineProperty(exports, "SwapAccount", {
  enumerable: true,
  get: function get() {
    return __importDefault(SwapAccount_1).default;
  }
});

var SwapAccountMobile_1 = require("./Header/SwapAccount/SwapAccountMobile");

Object.defineProperty(exports, "SwapAccountMobile", {
  enumerable: true,
  get: function get() {
    return __importDefault(SwapAccountMobile_1).default;
  }
});

var Constants_1 = require("./common/Constants");

Object.defineProperty(exports, "STORE", {
  enumerable: true,
  get: function get() {
    return Constants_1.STORE;
  }
});